// Waehrung der Seite fuer Anzeige, Tracking und Zahlungs-SDKs (Task 186). reference: [1]
export function waehrung() {
    return document.querySelector('m7-checkout')?.dataset?.currency || 'EUR';
}
